<fieldset class="hvac-radio-group" role="radiogroup" [attr.name]="name">
    <legend>{{legend}}</legend>
    <ng-content></ng-content>
</fieldset>
